const fontSizes = {
  superHeading1: "56px",
  superHeading2: "40px",
  superHeading3: "36px",
  superHeading4: "32px",
  superHeading5: "24px",
  superHeading6: "18px",
  heading1: "34px",
  heading2: "20px",
  heading3: "16px",
  body: "14px",
  info: "12px",
  // Add more as needed
};

const smallFontSizes = {
  heading1: "34px",
  heading2: "20px",
  body: "14px",
  info: "13px",
  // Add more as needed
};

export { fontSizes, smallFontSizes };
